<template>
    <Title_Base :icon="icon" :title="text">
    </Title_Base>
</template>


<script>
import Title_Base from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Base.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
    name: 'Title_Counter',
    props: {},
    components: {
        Title_Base,
    },

    data() {
        return {
            entityName: EntityNames.Counter,
        };
    },

    methods: {},

    computed: {
        icon() {
            return "$counter";
        },

        text() {
            if (this.loading || !this.item) {
                return this.$t('servicesystem.common_objects.commonterms.loading_placeholder', { pkey: this.$t('servicesystem.common_objects.counter.counter') });
            }
            else {
                return `${this.item.Id} ${this.item.Name}`;
            }
        },

        item() {
            return this.$store.getters["entitycontainerstore/getEntity"](this.entityName);
        },

        loading() {
            return this.$store.getters["entitycontainerstore/getEntityLoading"](this.entityName);
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>